// extracted by mini-css-extract-plugin
var _1 = "T2iChczVR4Thas4HNiOS";
var _2 = "T2iChczVR4Thas4HNiOS";
var _3 = "xX8lRP7UZ8RDRhkh50yg";
var _4 = "xX8lRP7UZ8RDRhkh50yg";
var _5 = "bEKBiyaQOdIEG30zeU_E";
var _6 = "GVed83Et18zyaGmem4D5";
export { _1 as "button-row", _2 as "buttonRow", _3 as "cancel-link", _4 as "cancelLink", _5 as "heading", _6 as "wrapper" }
